import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneClassroom from '../ones/OneClassroom';
import { MdAdd, MdCheck, MdDelete, MdSms, MdWhatsapp } from "react-icons/md";

export default function SubjectRegistrationForm({ data }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [firstName, setFirstName] = useState("");
	const [middleName, setMiddleName] = useState("");
	const [lastName, setLastName] = useState("");
	const [phone, setPhone] = useState("");
	const [gender, setGender] = useState("male");
	const [nidaNumber, setNidaNumber] = useState("");
	const [roles, setRoles] = useState([""]);


	async function init() {
		//run initializations here
		setReady(false);
		//..
		setReady(true);
	}

	function resetForm() {
		setFirstName("");
		setMiddleName("");
		setLastName("");
		setPhone("");
		setGender("male");
		setNidaNumber("");
		setRoles([""]);
	}

	function addRoles() {
		setRoles(_prev => {
			const _new = [..._prev];
			_new.push("");

			return _new;
		});
	}

	function handleRoleChange(index, value) {
		setRoles(_prev => {
			const _new = [..._prev];
			_new[index] = value;

			return _new;
		});
	}

	function deleteRole(index) {
		setRoles(_prev => {
			const _new = [..._prev];
			
			_new.splice(index, 1);

			return _new;
		});
	}

	function cleanRoles(_raw) {
		return [...new Set(_raw.filter(item => item?.trim()))];
	}


	async function create() {

		const _roles = cleanRoles(roles);

		if(_roles && _roles.length > 0) {
			if(phone.trim().length === 12) {
				if(firstName.trim().length > 0) {
					if(middleName.trim().length > 0) {
						if(lastName.trim().length > 0) {
							if(gender.trim().length > 0) {
								setLoading(true);
								await callApi(
									'register-staff',
									{
										schoolUuid: appContext.currentSchoolUuid,
										firstName,
										middleName,
										lastName,
										phone,
										gender,
										nidaNumber,
										roles: JSON.stringify(_roles),
									}
								).then(response => {
									if(response.status === 1) {
										appContext.tellMessage("Successful");
										resetForm();
										appContext.getAllStaff();
									} else {
										appContext.tellError(response.msg);
									}
								})
								setLoading(false);
							} else {
								appContext.tellError("Invalid gender");
							}
						} else {
							appContext.tellError("Invalid last name");
						}
					} else {
						appContext.tellError("Invalid middle name");
					}
				} else {
					appContext.tellError("Invalid first name");
				}
			} else {
				appContext.tellError("Invalid phone number");
			}
		} else {
			appContext.tellError("Invalid roles");
		}

		
	}

	useEffect(() => {
		init();
	}, [])

	

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
		
			<div className="row">
				<div className="col-md-4 mt-2 mb-2">
					<label className="form-label">Staff's First Name</label>
					<input
						className="form-control"
						value={firstName}
						onChange={e => setFirstName(e.target.value)}
					/>
				</div>

				<div className="col-md-4 mt-2 mb-2">
					<label className="form-label">Staff's Middle Name</label>
					<input
						className="form-control"
						value={middleName}
						onChange={e => setMiddleName(e.target.value)}
					/>
				</div>

				<div className="col-md-4 mt-2 mb-2">
					<label className="form-label">Staff's Last Name</label>
					<input
						className="form-control"
						value={lastName}
						onChange={e => setLastName(e.target.value)}
					/>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Staff's Phone Number</label>
					<input
						className="form-control"
						value={phone}
						onChange={e => setPhone(e.target.value)}
						maxLength={12}
					/>
					<div className="form-text">
						Include Country code eg 2557XXXXXXXX. Will be used for Staff Login
					</div>
				</div>

				<div className="col-md-6 mt-2 mb-2">
					<label className="form-label">Staff's Gender</label>
					<select
						className="form-control"
						value={gender}
						onChange={e => setGender(e.target.value)}
					>
						<option value="male" >Male</option>
						<option value="female" >Female</option>
					</select>
					
				</div>

				<div className="col-md-12 mt-2 mb-2">
					<label className="form-label">Roles</label>
					<div
						style={{
							width: "100%",
							padding: "10px",
							border: "2px solid var(--darkColor)",
						}}
					>
						{
							roles.map((item, i) => {
								return (
									<div className="d-flex" key={i}>
										<select
											
											className="form-control align-self-center"
											value={item}
											onChange={e => handleRoleChange(i, e.target.value)}
											style={{
												margin: "5px",
											}}
										>
											<option value="" >Click to select</option>
											{JSON.parse(appContext.systemParams.supportedStaffRoles).map((item, i) => {
												return (
													<option key={i} value={item.id}>{item.description}</option>
												)
											})}
										</select>

										<MdDelete
											style={{
												flexShrink: 0,
												cursor: "pointer",
											}}
											size={32}
											className="text-danger align-self-center"
											onClick={() => deleteRole(i)}
										/>
									</div>
								)
							})
						}

						<button
							className="btn btn-sm btn-outline-dark"
							onClick={addRoles}
						>
							<MdAdd size={24}/>
						</button>
					</div>
					<div className="form-text">
						Select Applicable roles to for this staff member
					</div>
					
				</div>

				<div className="col-md-12 mt-2 mb-2 text-end">
					<button
						className="btn btn-secondary"
						onClick={() => {
							appContext.activateDialog({
								message: `Register new staff member, ${firstName} ${middleName} ${lastName}?`,
								onConfirm: create,
							})
						}}
					>
						<MdCheck/> Submit
					</button>
				</div>
			</div>
								
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}